<template>
  <div>
    <b-alert :show="showAlert" variant="danger" dismissible>
      <h6 class="alert-heading">
        <b-icon-exclamation-circle-fill
          variant="danger"
        ></b-icon-exclamation-circle-fill>
        Não foi possível gerar guia de pagamento para o auto de infração de
        trânsito: {{ auto_infracao_transito.num_ait_composto }}
      </h6>
      <p>
        Entre em contato ou utilize uma das seguintes alternativas para emissão
        da guia da pagamento :
      </p>
      <ul>
        <li>
        <b-link
          target="_blank"
          class="text-primary"
          href="https://servicos.pbh.gov.br/servicos/i/5fdb7b00bbfc827e9ece9aea/5dc8470253fd6b5bbd99185f/servicos%2Bguias-multa-de-transito-nao-inscritas-em-divida-ativa"
          >Guias - Multa de Trânsito - Não Inscritas em Dívida Ativa</b-link></li>
        <li>
          <b-link
          target="_blank"
          class="text-primary"
          href="https://detran.mg.gov.br/veiculos/situacao-do-veiculo/emitir-de-extrato-de-multas"
          >DETRAN - MG - Emitir Boleto de Multa</b-link></li>
      </ul>
    </b-alert>
    <b-row>
      <b-col sm="3">
        <b-form-group
          label="Quitada?"
          label-size="sm"
          label-class="text-secondary"
        >
          <span
            :class="
              `font-weight-bold text-` +
              getVariantStatus(auto_infracao_transito.ind_multa_quitada)
            "
          >
            {{
              temValor(
                obterStatusSimNao(auto_infracao_transito.ind_multa_quitada)
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Inscrita Dívida Ativa?"
          label-size="sm"
          label-class="text-secondary"
        >
          <span
            :class="
              `font-weight-bold text-` +
              getVariantStatus(!auto_infracao_transito.ind_multa_divida_ativa)
            "
          >
            {{
              temValor(
                obterStatusSimNao(auto_infracao_transito.ind_multa_divida_ativa)
              )
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3" v-if="auto_infracao_transito.temPenalidade() && !auto_infracao_transito.isCancelado()">
        <b-form-group
          label="Prazo Vencimento - Pagamento Com Desconto"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{
              temValor(dataBrasil(auto_infracao_transito.prazo_recurso_jari))
            }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="3">
        <b-form-group
          label="Valor da Infração"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(formataReal(valorDaInfracao))}}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col sm="12">
        <p>
          <strong>Guia para pagamento</strong>
        </p>
        <p class="ml-3" v-if="exibirBtnGuia()">
          Deseja emitir uma guia para pagamento antecipado ou emitir nova guia
          de pagamento? Utilize o link abaixo.
        </p>
        <b-row v-if="exibirBtnGuia()" class="text-center mb-5">
          <b-col sm="12">
            <b-button  pill @click="emitirGuia()" size="sm" variant="success">
              <font-awesome-icon :icon="['far', 'file-lines']" title="Emitir Guia de Pagamento"/>
              Emitir Guia de Pagamento (DRAM)
            </b-button>
          </b-col>
        </b-row>
        <ul>
          <li class="mb-3">
            Para multas que possuem Adesão ao SNE - Sistema Notificação
            Eletrônica (Nacional), o pagamento com desconto de 40% só pode ser
            feito através de guias geradas pelo aplicativo. Para orientações:
            <b-link
              target="_blank"
              class="text-primary"
              href="https://www.gov.br/prf/pt-br/assuntos/sistema-de-notificacao-eletronica-sne"
              >acesse aqui</b-link
            >. O SNE está no aplicativo Carteira Digital de Trânsito - CDT,
            <b-link
              target="_blank"
              class="text-primary"
              href="https://www.loja.serpro.gov.br/sne"
              >acesse aqui para instalar</b-link
            >
          </li>
          <li>
            Se sua multa está inscrita em Dívida Ativa, emita sua guia para
            pagamento conforme orientações do serviço:
            <b-link
              target="_blank"
              class="text-primary"
              href="https://servicos.pbh.gov.br/servicos/i/5fa3f72d0ceeee0a7e69ad9a/5dc8470253fd6b5bbd99185f/servicos+guias-multa-de-transito-inscritas-em-divida-ativa"
              >Guias - Multa de Trânsito - Inscritas em Dívida Ativa</b-link
            >
          </li>
        </ul>
        <p></p>
      </b-col>
    </b-row>
    <b-modal
      v-model="modalShow"
      centered
      hide-footer
      id="modal-lg"
      size="xl"
      ref="modal"
    >
      <div>
        <b-embed
          type="iframe"
          aspect="21by9"
          :src="imgMidia"
          allowfullscreen
        ></b-embed>
      </div>
    </b-modal>
  </div>
</template>

<script>
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";
import helpers from "@/helpers";
import { helperDatas, helperNumeros } from "@/helpers";

export default {
  name: "SegundaVia",

  components: {},

  props: {
    auto_infracao_transito: {
      type: Object,
      default: function () {
        return new AutoInfracaoTransito();
      },
    },
    multa_nic:{
      type: Object,
      default: function () { return {}; },
    },
  },

  data() {
    return {
      imgMidia: null,
      tipoResource: null,
      exibirMsgErro: false,
      msgErro: "",
      modalShow: false,
      showAlert: false,
      listaErroGuia: [],
    };
  },

  computed: {
    mobile() {
      return helpers.isMobile();
    },

    isMultaNIC() {
      return this.auto_infracao_transito.isMultaNIC()
    },

    valorDaInfracao()
    {
      return this. isMultaNIC && this.multa_nic ? this.multa_nic.valor_infracao : this.auto_infracao_transito.vigencia_codigo_infracao.valor_infracao
    },

  },

  methods: {
    exibirBtnGuia() {
      if (
        this.auto_infracao_transito.ind_multa_quitada ||
        this.auto_infracao_transito.ind_multa_prescrita ||
        this.auto_infracao_transito.status_auto_infracao_transito.codigo_status == 9 || 
        this.auto_infracao_transito.status_auto_infracao_transito.codigo_status == 18 
      ) {
        return false;
      } else return true;
    },

    formataReal(valor) {
      return helperNumeros.formatReal(valor);
    },
    obterStatusSimNao(status) {
      return status ? "Sim" : "Não";
    },
    getVariantStatus(status) {
      return status ? "dark" : "danger";
    },
    dataBrasil(valor) {
      return helperDatas.dataBrasil(valor);
    },
    temValor(valor) {
      return valor ? valor : "-";
    },

    cpfCnpf() {
      var keys = Object.keys(this.$store.getters.userInfo.attributes);
      const result = keys.filter(
        (element) => element.substring(10, 0) == "govbr_cnpj"
      );
      let listaCpfCnpj = [];
      listaCpfCnpj.push(this.$store.getters.userInfo.preferred_username);
      if (result.length > 0) {
        result.forEach((element) => {
          listaCpfCnpj.push(element.substring(25, 11));
        });
      }
      return listaCpfCnpj;
    },   

    emitirGuia() {


      if(this.auto_infracao_transito.ind_multa_divida_ativa == true) 
      {
        window.open('https://servicos.pbh.gov.br/servicos/i/5fa3f72d0ceeee0a7e69ad9a/5dc8470253fd6b5bbd99185f/servicos+guias-multa-de-transito-inscritas-em-divida-ativa', 'mozillaTab');
        return;
      }

      this.showAlert = false;
      this.listaErroGuia = [];

      let cpfCnpj = this.cpfCnpf();

      this.$api.Multa.downloadGuiaAit({
        hash: this.auto_infracao_transito.hash, ohnpw:cpfCnpj
      })
        .then((response) => {
          if (response.status == 200) {
            if (this.mobile) {
              var a = document.createElement("a");
              a.href = "data:application/pdf;base64," + response.data.data.content;
              a.download = response.data.data.filename;
              a.click();
            } else {
              this.tipoResource = "pdf";
              this.imgMidia =
                "data:application/pdf;base64," + response.data.data.content;
              this.modalShow = true;
            }
          }
        })
        .catch((error) => {
          this.showAlert = true;
          error.response.data.errors.forEach((element) => {
            this.listaErroGuia.push(element);
          });
        });
    },
  },
};
</script>

<style scoped>
</style>